import { gql } from '@apollo/client';
import metadataOperationResultFragment from '@shared/queries/metadataOperationResultFragment';

const DEACTIVATE_LICENSE = gql`
  mutation DeactivateUserLicense($externalUserId: Int!) {
    deactivateUserLicense(externalUserId: $externalUserId) {
      ...MetadataOperationResultFields
    }
  }
  ${metadataOperationResultFragment}
`;

export default DEACTIVATE_LICENSE;
